import { GeoEditAdapter } from './GeoEditSession';
import type { GeoEditOperation } from '@visualizer/types';
import type { RemoveBuildingOp, RemoveTreeOp, EditGroundOp, AddBuildingOp } from '@visualizer/types';

export interface BuildingsEditAdapter {
    // Remove
    applyRemove(op: RemoveBuildingOp): void;
    revertRemove(op: RemoveBuildingOp): void;

    // Add
    applyAdd(op: AddBuildingOp): void;
    revertAdd(op: AddBuildingOp): void;
}

export interface TreesEditAdapter {
    applyRemove(op: RemoveTreeOp): void;
    revertRemove(op: RemoveTreeOp): void;
}

export interface GroundEditAdapter {
    applyEdit(op: EditGroundOp): void;
    revertEdit(op: EditGroundOp): void;
}

export class CompositeGeoEditAdapter implements GeoEditAdapter {
    constructor(
        private readonly buildings?: BuildingsEditAdapter | null,
        private readonly trees?: TreesEditAdapter | null,
        private readonly ground?: GroundEditAdapter | null
    ) {}

    apply(op: GeoEditOperation): void {
        if (op.command === 'REMOVE' && op.dataType === 'building') {
            this.buildings?.applyRemove(op);
        } else if (op.command === 'REMOVE' && op.dataType === 'tree') {
            this.trees?.applyRemove(op);
        } else if (op.command === 'EDIT' && op.dataType === 'ground') {
            this.ground?.applyEdit(op);
        } else if (op.command === 'ADD' && op.dataType === 'building') {
            this.buildings?.applyAdd(op);
        }
    }

    revert(op: GeoEditOperation): void {
        if (op.command === 'REMOVE' && op.dataType === 'building') {
            this.buildings?.revertRemove(op);
        } else if (op.command === 'REMOVE' && op.dataType === 'tree') {
            this.trees?.revertRemove(op);
        } else if (op.command === 'EDIT' && op.dataType === 'ground') {
            this.ground?.revertEdit(op);
        } else if (op.command === 'ADD' && op.dataType === 'building') {
            this.buildings?.revertAdd(op);
        }
    }
}
